import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const CatalogosPage = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const productos = [
    {
      id: 1,
      name: 'Arreglos Florales',
      description: 'Diseños únicos y personalizados',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/89bfcc7c-a9c8-443f-8fab-f50a81d06500/publicContain',
      path: '/producto/arreglos',
      alt: 'Arreglos florales premium en Arequipa - Flores frescas a domicilio'
    },
    {
      id: 2,
      name: 'Boxes Florales',
      description: 'Presentación especial elegante',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/85bbe1af-b296-4087-84a8-81845666be00/publicContain',
      path: '/producto/boxes',
      alt: 'Boxes de flores elegantes Arequipa - Cajas florales premium'
    },
    {
      id: 3,
      name: 'Peluches y Flores',
      description: 'Tiernos detalles con flores',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/080fe01b-7b1a-47fc-e3ff-719967432100/publicContain',
      path: '/producto/peluches',
      alt: 'Peluches con flores Arequipa - Regalos románticos y tiernos'
    },
    {
      id: 4,
      name: 'Detalles Especiales',
      description: 'Momentos especiales únicos',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f3a481d2-b9de-472b-98c2-8ba5f68d7200/public',
      path: '/producto/detalles',
      alt: 'Detalles florales especiales Arequipa - Pequeños regalos con flores'
    },
    {
      id: 5,
      name: 'Ramos de Flores',
      description: 'Para toda ocasión',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/087f35d1-48ca-4540-4281-08990078ee00/public',
      path: '/producto/ramos',
      alt: 'Ramos de flores frescas Arequipa - Rosas, lirios, girasoles'
    },
    {
      id: 6,
      name: 'Eventos y Bodas',
      description: 'Decoración floral profesional',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2d4938a6-6347-4c70-6431-f5ef464fb800/publicContain',
      path: '/producto/eventos',
      alt: 'Decoración floral para eventos Arequipa - Bodas y fiestas'
    }
  ];

  const destacados = [
    {
      id: 1,
      name: 'Flores Variadas Premium',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a786cc17-edfc-44f5-7190-d8b1a4e5ae00/publicContain',
      path: '/producto/arreglos',
      alt: 'Flores variadas premium Arequipa - Arreglos florales mixtos'
    },
    {
      id: 2,
      name: 'Girasoles Alegres',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/54aef800-701d-4185-5244-1ad2e1980900/public',
      path: '/producto/girasoles',
      alt: 'Girasoles frescos Arequipa - Flores amarillas delivery'
    },
    {
      id: 3,
      name: 'Rosas Románticas',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/3c289914-6f7b-48bf-5f2f-456ab5303900/public',
      path: '/producto/rosas',
      alt: 'Ramos de rosas rojas Arequipa - Flores románticas'
    },
    {
      id: 4,
      name: 'Lirios Elegantes',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8728d7bc-6b77-49b4-7bbe-77f98df9f300/public',
      path: '/producto/lirios',
      alt: 'Lirios frescos Arequipa - Arreglos con lirios premium'
    },
    {
      id: 5,
      name: 'Tulipanes Importados',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a05fc3c6-28c6-47f3-8d07-3eb725c33800/publicContain',
      path: '/producto/tulipanes',
      alt: 'Tulipanes frescos Arequipa - Flores importadas delivery'
    },
    {
      id: 6,
      name: 'Combos Especiales',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/4fad6589-8981-4513-ea15-0933c0a21b00/publicContain',
      path: '/producto/arreglos',
      alt: 'Combos florales Arequipa - Packs especiales con flores'
    }
  ];

  return (
    <div className="min-h-screen bg-pink-50 pt-16 md:pt-20">
      <SEO 
        title="Catálogo de Flores y Arreglos Florales"
        description="Catálogo completo de flores en Arequipa: ramos de rosas, lirios, girasoles, arreglos florales, boxes, peluches y más. Delivery express el mismo día."
        keywords="catalogo flores arequipa, ramos de rosas arequipa, lirios arequipa, girasoles arequipa, arreglos florales arequipa, boxes florales arequipa, peluches con flores arequipa, flores a domicilio arequipa, comprar flores arequipa"
      />
      
      {/* Hero Section */}
      <section 
        className="py-20 px-4"
        style={{
          backgroundImage: 'url(https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e9bba638-d807-427f-bea3-a775809cad00/publicContain)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-pink-900 mb-6">
            Nuestros Catálogos
          </h1>
          <p className="text-xl md:text-2xl text-pink-800">
            Descubre nuestra colección completa de arreglos florales en Arequipa
          </p>
        </div>
      </section>

      {/* Nuestros Productos */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-pink-900 mb-4">
            Nuestros Productos
          </h2>
          <p className="text-center text-pink-700 text-lg mb-12">
            Click en cada producto para ver más detalles y hacer tu pedido
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {productos.map((producto) => (
              <div 
                key={producto.id}
                onClick={() => handleNavigation(producto.path)}
                className="group overflow-hidden bg-pink-50 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
              >
                <div className="relative aspect-square overflow-hidden">
                  <img 
                    src={producto.image}
                    alt={producto.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-pink-900/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-2xl font-bold text-pink-900 mb-2">{producto.name}</h3>
                  <p className="text-pink-700 mb-3">{producto.description}</p>
                  <p className="text-sm text-pink-500">Click para ver detalles →</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Productos Destacados */}
      <section className="py-16 px-4 bg-pink-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-pink-900 mb-4">
            Productos Destacados
          </h2>
          <p className="text-center text-pink-700 text-lg mb-12">
            Los favoritos de nuestros clientes en Arequipa
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {destacados.map((producto) => (
              <div 
                key={producto.id}
                onClick={() => handleNavigation(producto.path)}
                className="group overflow-hidden bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
              >
                <div className="relative aspect-square overflow-hidden">
                  <img 
                    src={producto.image}
                    alt={producto.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-pink-900/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-8">
                    <span className="text-white font-bold text-xl">{producto.name}</span>
                  </div>
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-pink-900 mb-2">{producto.name}</h3>
                  <p className="text-sm text-pink-500 mt-2">Ver más →</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-pink-900 mb-6">
            ¿No encuentras lo que buscas?
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            Contáctanos y creamos un arreglo personalizado para ti
          </p>
          <button
            onClick={() => window.open('https://wa.me/51959389799?text=Hola,%20quiero%20un%20arreglo%20personalizado', '_blank')}
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-2"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            Pedir Arreglo Personalizado
          </button>
        </div>
      </section>
    </div>
  );
};

export default CatalogosPage;